var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJewelry4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Woman_x5F_jewelry"
  }, /*#__PURE__*/React.createElement("g", {
    id: "jewelry_x5F_2_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6F4C26",
    d: "M430.1,433.6c-0.7-1.1-1.8-1.8-3.2-2c0.2,0.6,0.4,1.2,0.7,1.8c0.5,0.3,1,0.6,1.2,1.1 c0.5,0.8,0.5,1.8-0.1,2.7c-0.9,1.5-3.3,2.7-5,3.5l-0.3,0.2c-6.5,3.2-13.3,5-20.4,6.8c-3,0.8-6.1,1.6-9.1,2.5 c-1.1,0.3-2.2,0.7-3.4,1c-8.5,2.4-19,5.4-23.8,13.3c-2.2,3.6-1.5,7-0.9,10.4c0.3,1.9,0.6,3.6,0.5,5.4c-0.2,2.4-1.2,4.6-3,6.1 c-1.5,1.3-3.4,2.1-5.5,2.1l0,0c-0.1,0-0.3,0-0.4,0s-0.3,0-0.4,0l0,0c-4.4-0.1-7.6-3.4-8.1-8.5c-0.2-1.9,0.2-3.5,0.5-5 c0.5-2.6,1.1-5.3-1-8.8c-4.2-6.9-13.5-8.2-21.8-9.3c-2.7-0.4-5.2-0.7-7.4-1.2c-15.7-3.6-22.7-7.7-28.5-12.9 c-1.4-1.2-3.6-4.1-4.5-6.2c-0.6-1.4-0.5-2.6,0.1-3.5c0.3-0.4,0.7-0.7,1.2-0.8c0.2-0.5,0.4-1.1,0.6-1.6c-1.3,0.1-2.3,0.7-3,1.6 c-0.9,1.3-1,3-0.2,4.9c1,2.4,3.3,5.4,4.9,6.8c6,5.3,13.2,9.5,29.2,13.2c2.3,0.5,4.9,0.9,7.6,1.3c7.9,1.1,16.9,2.4,20.7,8.6 c1.8,3,1.3,5.2,0.8,7.7c-0.3,1.6-0.7,3.3-0.5,5.4c0.5,6,4.4,9.8,9.6,9.8c0.1,0,0.2,0,0.4,0c0.1,0,0.2,0,0.3,0 c2.4,0,4.7-0.9,6.6-2.5c2.1-1.8,3.3-4.3,3.5-7.1c0.1-2-0.2-3.9-0.6-5.8c-0.6-3.2-1.1-6.3,0.7-9.4c4.5-7.3,14.7-10.3,22.9-12.6 c1.2-0.3,2.4-0.7,3.5-1c3-0.9,6.1-1.7,9-2.5c6.9-1.8,14-3.7,20.7-6.9l0.3-0.2c1.8-0.9,4.5-2.2,5.6-4.1 C430.8,436.4,430.9,434.9,430.1,433.6z"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#46905F",
    cx: 368.2,
    cy: 462.6,
    r: 3.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#46905F",
    d: "M368.2,459.2c-1.8,0-3.3,1.5-3.3,3.3c0,0.8,0.3,1.4,0.7,2l5-4.4C370,459.6,369.1,459.2,368.2,459.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#80F3A7",
    d: "M370.5,460.2l-5,4.4c0.6,0.8,1.6,1.3,2.6,1.3c1.8,0,3.3-1.5,3.3-3.3C371.6,461.6,371.2,460.8,370.5,460.2 z"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#46905F",
    cx: 345.3,
    cy: 462.7,
    r: 3.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#46905F",
    d: "M345.3,459.3c-1.8,0-3.3,1.5-3.3,3.3c0,0.8,0.3,1.4,0.7,2l5-4.4C347,459.7,346.2,459.3,345.3,459.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#80F3A7",
    d: "M347.6,460.3l-5,4.4c0.6,0.8,1.6,1.3,2.6,1.3c1.8,0,3.3-1.5,3.3-3.3C348.6,461.7,348.2,460.9,347.6,460.3 z"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#46905F",
    cx: 357.5,
    cy: 479.8,
    r: 9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#80F3A7",
    d: "M361.7,471.8L350.1,485c1,1.5,2.5,2.7,4.2,3.3l11.2-12.7C364.6,474,363.3,472.7,361.7,471.8z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJewelry4);
export default __webpack_public_path__ + "static/media/jewelry_4.c6fa3d707e29b8f9134776469c5a560e.svg";
export { ForwardRef as ReactComponent };